import React from 'react';
import Link from 'gatsby-link';

import ServiceCarousel from "../ServiceCarousel"

class ServiceBlock extends React.Component {
  constructor(props, context) {
    super(props, context)

    this.node = props.node
    this.baseurl = props.baseurl
  }

  render() {
    return (
      <div className="col-md-6 col-lg-3 mb-2" key={this.node.wordpress_id}>
        <div className="card" key={`card_${this.node.wordpress_id}`}>
          <div className="card-header p-0">
            <ServiceCarousel node={this.node}></ServiceCarousel>
          </div>
          <div className="card-body">
            <h2 className="h4">
              <Link to={`${this.baseurl}/${this.node.slug}/`} dangerouslySetInnerHTML={{__html: `${this.node.title}`}}></Link>
            </h2>
          </div>
        </div>
      </div>
    )
  }
}

export default ServiceBlock;



// WEBPACK FOOTER //
// ./src/components/ServiceBlock/index.jsx